import * as React from 'react';
import { ComponentProps } from 'ui/common';

export const FactItemPanel = (props: ComponentProps) => {
  return <>{props.children}</>;
};
